(function () {
  if (window.__premReportStorefrontInit) return;
  window.__premReportStorefrontInit = true;

  function subscribedSkusFromFetchData(raw) {
    if (!raw) return [];
    try {
      var data = typeof raw === 'string' ? JSON.parse(raw) : raw;
      var skus =
        (data.subscriber_list && data.subscriber_list.subscribed_products) ||
        data.records ||
        [];
      return Array.isArray(skus) ? skus : [];
    } catch (e) {
      return [];
    }
  }

  function containsFreePremReport(skus, premReport) {
    if (!premReport) return false;
    return skus.some(function (sku) {
      var s = String(sku);
      return s === premReport || s.indexOf(premReport) !== -1;
    });
  }

  function handlePremReportDisplay(PREM_REPORT) {
    var prem = PREM_REPORT || window.PREM_REPORT;
    var el = document.getElementById('prem_report_card');
    if (!el) return;

    var raw = localStorage.getItem('fetchData');
    var totalDeviceCount = parseInt(localStorage.getItem('total_device_count'), 10);
    var countOk = Number.isFinite(totalDeviceCount) && totalDeviceCount >= 200;

    if (!raw) {
      el.style.display = 'none';
      return;
    }

    var skus = subscribedSkusFromFetchData(raw);
    if (containsFreePremReport(skus, prem)) {
      el.style.display = 'none';
      return;
    }

    if (countOk) {
      el.style.display = 'block';
    } else {
      el.style.display = 'none';
    }
  }

  window.handlePremReportDisplay = handlePremReportDisplay;

  function scheduleApply() {
    requestAnimationFrame(function () {
      handlePremReportDisplay(window.PREM_REPORT);
    });
  }

  document.addEventListener('DOMContentLoaded', scheduleApply);
  document.addEventListener('apiCallsComplete', scheduleApply);
  document.addEventListener('product-grid:updated', scheduleApply);
  document.addEventListener('shopify:section:load', scheduleApply);
})();
